import { AutoplayDetection } from './autoplay-detection';
import { CanAutoPlayResult } from './can-autoplay';

/**
 * On SetTop boxes, tizen and webos the autoplay detection is skipped
 */
export class TVAutoplayDetection extends AutoplayDetection {
  protected isAutoplaySupportedForPlatform(): Promise<CanAutoPlayResult> {
    return Promise.resolve({ result: true });
  }
}
